import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Text } from 'components/core/Typography';
import { CardBadge } from 'components/core/CardBadge';

import './badgedListItem.scss';

export default function BadgedListItem({
	color,
	icon,
	name,
	classname,
	tooltipMessage,
	facilityMessage
}) {
	return (
		<div className={classnames('badged-list-item', classname)}>
			<CardBadge
				color={color}
				parentPadding="medium"
				icon={icon}
				tooltipMessage={tooltipMessage}
				clickToCloseTooltip
				hideTooltipForLarge
			>
				<Text color="white" weight="bold" size="tiny" last>{name}</Text>
			</CardBadge>
			<Text
				className="badge-message"
				weight="light"
				size="tiny"
				last
			>
				{facilityMessage}
			</Text>
		</div>
	);
}

BadgedListItem.propTypes = {
	name: PropTypes.string,
	classname: PropTypes.string,
	color: PropTypes.string,
	icon: PropTypes.func,
	tooltipMessage: PropTypes.string,
	facilityMessage: PropTypes.string
};
